import axios from 'axios';
import moment from 'moment';
import '@/filters';
import users from '@/users';
import enquiriesTools from '@/employee/enquiries/enquiriesTools';

export default {
  name: 'customerHistory',
  components: {
    DataGridComp: require('@/customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
    LoadingIndicator: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
    MenuListItem: require('@/employee/enquiries/menuListItem.vue').default,
  },
  mixins: [users, enquiriesTools],
  data: function () {
    return {
      settingFor: 'customer',
      isDetLoading: true,
      customerAllData: null,
      menuVisible: true,
      customerName: '',
      lang: '',

      property: null,
      propertyHistory: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "ownerCustkey",
        isLoading: true,
      },
      connectionHistory: {
        cols: [],
        data: [],
        totalRow: 0,
        pageingOption: { pageSize: 10, total: 0, page: 1 },
        keyCol: "accountName",
        isLoading: true,
      },    

      propId: null,
      custkey: null,

      pagesLoaded: ['PropertyHistory', 'ConnectionHistory'],
    }
  },
  mounted() {
    this.goToDefaultTab(this.selectedTab);
  },
  computed: {   
    isLoading: function () {
      return this.propertyHistory.isLoading && this.connectionHistory.isLoading ;
    },
    showEmptyState: function () {
      if ( (this.propertyHistory.data.length == 0 && this.selectedTab == 'PropertyHistory') ||
        (this.connectionHistory.data.length == 0 && this.selectedTab == 'ConnectionHistory') )
        return true;
      else
        return false;
    },
  },
  watch: {
    selectedTab: function (val) {
      switch (val) {
        default:
          this.$root.$emit(`refresh_data_grid:${val}DataGrid`);
          break;
      }

      this.changeUrlLink(val);
    }
  },
  methods: {
    init() {
      this.propId = this.$route.params.propertyId;
      this.custkey = this.$route.params.custkey;

      this.selectedTab = 'PropertyHistory';
      this.isHistoryExpanded = true;

      this.fillColumns();
      this.getData();
    },
    fillColumns() {
      this.propertyHistory.cols.length = 0;
      this.connectionHistory.cols.length = 0;

      this.propertyHistory.cols.push({ dataField: 'docNo', caption: this.$t('enquiriesAccount.docNo') });
      this.propertyHistory.cols.push({ dataField: 'details', caption: this.$t('enquiriesAccount.details') });
      this.propertyHistory.cols.push({ dataField: 'date', caption: this.$t('enquiriesAccount.date') });
      this.propertyHistory.cols.push({ dataField: 'ownerCustkey', caption: this.$t('enquiriesAccount.ownerCustkey') });
      this.propertyHistory.cols.push({ dataField: 'ownerName', caption: this.$t('enquiriesAccount.ownerName') });
      this.propertyHistory.cols.push({ dataField: 'tenantCustkey', caption: this.$t('enquiriesAccount.tenantCustkey') });
      this.propertyHistory.cols.push({ dataField: 'tenantName', caption: this.$t('enquiriesAccount.tenantName') });

      this.connectionHistory.cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      this.connectionHistory.cols.push({ dataField: 'accountName', caption: this.$t('enquiriesAccount.accountName') });
      this.connectionHistory.cols.push({ dataField: 'date', caption: this.$t('enquiriesAccount.date'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.connectionHistory.cols.push({ dataField: 'meter', caption: this.$t('enquiriesAccount.meter') });
      this.connectionHistory.cols.push({ dataField: 'reading', caption: this.$t('enquiriesAccount.reading') });
      this.connectionHistory.cols.push({ dataField: 'disconnection', caption: this.$t('enquiriesAccount.disconnection') });
      this.connectionHistory.cols.push({ dataField: 'reconnecton', caption: this.$t('enquiriesAccount.reconnecton') });
      this.connectionHistory.cols.push({ dataField: 'balance', caption: this.$t('enquiriesAccount.amountDue') });
      this.connectionHistory.cols.push({ dataField: 'applicationId', caption: this.$t('enquiriesAccount.applicationId') });
      this.connectionHistory.cols.push({ dataField: 'dmCaseId', caption: this.$t('enquiriesAccount.dmCaseId') });      
    },
    getData() {
      this.getConnectionHistory(true);
      this.getPropertyHistory(true);

      this.getCustomerDisplayInfo();
    },

    getPropertyHistory(loader = false) {
      this.propertyHistory.isLoading = loader;

      var parameters = {
        propertyId: this.propId,
        loginEmail: this.getLoginName(),
        Options: this.propertyHistory.pageingOption
      }

      axios.post('/Enquiries/getPropertyHistory', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.propertyHistory.data = response.data.items;
            this.propertyHistory.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
          //this.$router.push('/login');
        })
        .finally(() => this.propertyHistory.isLoading = false);

    },
    getConnectionHistory(loader = false) {
      this.connectionHistory.isLoading = loader;

      var parameters = {
        propertyId: this.propId,
        connectionId: 0,
        loginEmail: this.getLoginName(),
        Options: this.connectionHistory.pageingOption
      }

      axios.post('/Enquiries/getConnectionHistory', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.connectionHistory.data = response.data.items;
            this.connectionHistory.totalRow = response.data.itemsCount;
          }
          else {
            this.getDataFailed();
            this.$oldAlertMsg(response.data.data.text, 4);
          }
        })
        .catch(e => {
          this.getDataFailed();
          this.$oldAlertMsg(e, 4);
          //this.$router.push('/login');
        })
        .finally(() => this.connectionHistory.isLoading = false);
    },
  },
}
